
export class ReceiptDetail {
  id: number;
  receiptHeaderId: number;
  economicActId: number;
}
